import TripRateCalculationViewModel from "./TripRateCalculationViewModel";

export default class ExportTripRateGraphViewModel {
    exportType: "PDF" | "JPEG" = "PDF";
    addUserComments: boolean = false;
    userComment: string | null = null;
    displayToScreen: boolean = true;
    fileName: string = "";
    tripRate: TripRateCalculationViewModel = new TripRateCalculationViewModel();
}